import { render, staticRenderFns } from "./B.vue?vue&type=template&id=ba6ce1a4&scoped=true&"
import script from "./B.vue?vue&type=script&lang=js&"
export * from "./B.vue?vue&type=script&lang=js&"
import style0 from "./B.vue?vue&type=style&index=0&id=ba6ce1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6ce1a4",
  null
  
)

export default component.exports